/**
 * @author liqiuqi
 * @date 2022 2022/12/23 18:25
 */
import { omniAxios } from "@/utils/axios";
import { config } from "@/utils/config";

// 获取审批订阅器列表
export function restAccountApprovalSubscribeGetSubscriberListByUserId() {
  return omniAxios({
    url: config.restAccountApprovalSubscribeGetSubscriberListByUserIdPath,
    method: "get",
    params: {},
  });
}

// 获取审批订阅器
export function restAccountApprovalSubscribeGetSubscriberById({ id }) {
  return omniAxios({
    url: config.restAccountApprovalSubscribeGetSubscriberByIdPath + `/${id}`,
    method: "get",
    params: {},
  });
}

// 删除审批
export function restAccountApprovalSubscribeDelete({ id }) {
  return omniAxios({
    url: config.restAccountApprovalSubscribeDeletePath + `/${id}`,
    method: "get",
    params: {},
  });
}
